import { render } from "./App.vue?vue&type=template&id=6b9c915a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6b9c915a&lang=css&scoped=true"

import exportComponent from "/container/procurement-dev.jd.net.nz/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9c915a"]])

export default __exports__